export default __webpack_public_path__ + "static/choreography-light-b58e444044ff3bc5d35dec80607201df7741b2c777a67f96fec8a330773492ab.mp4";